import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors
} from '@material-ui/core';

import { get_all_showroom_timetable, get_showroom_details, get_agencies, get_showroom_agencies, add_property } from '../../../../api/API';


const useStyles = makeStyles(theme => ({
    root: {},

    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        },

    },

    flexend: {
        justifyContent: 'flex-end',
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
}));

export default function From(props) {

    const { profile, className, ...rest } = props;

    const classes = useStyles();

    const [openSnackbar, setOpenSnackbar] = useState(false);

    const [values, setValues] = useState({

    });

    const history = useHistory();

    const positions = ['Superadmin', 'Admin'];

    const handleChange = event => {
        event.persist();

        setValues({
            ...values,
            [event.target.name]:
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
        });
    };


    const handleSubmit = async event => {
        event.preventDefault();

        if(values.showroom == ""){
            alert("Please fill up all the necessary fields");
            return;
        }

        if(values.max_appointment == ""){
            alert("Please fill up all the necessary fields");
            return;
        }
        if(values.description == ""){
            alert("Please fill up all the necessary fields");
            return;
        }
        if(values.max_pax == ""){
            alert("Please fill up all the necessary fields");
            return;
        }
        if(values.short_name.length > 3){
            alert("Maxiumum 3 characters for short name");
            return;
        }
        const postparam = {
            name: values.showroom,
            description: values.description,
            max_appointment: values.max_appointment,
            max_pax: values.max_pax,
            require_showroom_unit: values.require_showroom_unit,
            short_name: values.short_name,
            require_guest_nationality: values.require_guest_nationality
        };

        let data = await add_property(postparam);
        if (data.status) {
            setOpenSnackbar(true);
            history.push("/showroom");
        }

    };

    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };


    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <form onSubmit={handleSubmit}>
                <CardHeader title="Create New Showroom" />
                <Divider />
                <CardContent>
                    <Grid
                        container
                        spacing={4}
                    >

                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Showroom"
                                name="showroom"
                                onChange={handleChange}
                                required
                                value={values.showroom}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Short Name"
                                name="short_name"
                                onChange={handleChange}
                                required
                                value={values.short_name}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Description"
                                name="description"
                                onChange={handleChange}
                                type="description"
                                required
                                value={values.description}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Max Pax Per Timeslot"
                                name="max_appointment"
                                onChange={handleChange}
                                type="number"
                                required
                                value={values.max_appointment}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Max Number of People Per Appointment"
                                name="max_pax"
                                onChange={handleChange}
                                type="number"
                                required
                                value={values.max_pax}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <FormControl component="fieldset">
                                <FormGroup aria-label="position" row>
                                    <FormControlLabel
                                        value="end"
                                        control={<Checkbox name="require_showroom_unit" color="primary" onChange={handleChange} />}
                                        label="Require showroom unit?"
                                        labelPlacement="end"
                                    />
                                </FormGroup>
                                <br></br>
                                <FormControl component="fieldset">
                                    <FormGroup aria-label="position" row>
                                        <FormControlLabel
                                            value="end"
                                            control={<Checkbox name="require_guest_nationality" color="primary" onChange={handleChange} />}
                                            label="Require Nationality?"
                                            labelPlacement="end"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </FormControl>
                        </Grid>

                    </Grid>
                </CardContent>
                <Divider />
                <CardActions className={classes.flexend}>
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: "black"
                        }}
                        onClick={() => {
                            history.goBack();
                        }}
                    >
                        <CancelIcon className={classes.leftIcon} />
                        Cancel
                </Button>
                    <Button
                        className={classes}
                        type="submit"
                        variant="contained"

                    >
                        <SaveIcon className={classes.leftIcon} />
                        Save Changes
                </Button>
                </CardActions>
            </form>
            {/* <SuccessSnackbar
            onClose={handleSnackbarClose}
            open={openSnackbar}
            /> */}
        </Card>
    )
}

